// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FOOTER_DOWNLOAD_ON_APP_STORE = "St\u00e1hni z App Store";
export const INSTALL_PROMPT_DESCRIPTION = "St\u00e1hni si novou kon\u00edkovskou apku do mobilu.";
export const INSTALL_PROMPT_DOWNLOAD_APP = "St\u00e1hni aplikaci";
